import "./ScreeningAndSeparationHub.module.css";
import React from "react";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import ScreeningHero from "./sections/ScreeningHero";
import ScreeningOverview from "./sections/ScreeningOverview";
import PowderScreeningPanel from "./sections/PowderScreeningPanel";
import MiningPanel from "./sections/MiningPanel";
import SolidLiquidPanel from "./sections/SolidLiquidPanel";
import Articles from "./sections/Articles";
import RecommendedProducts from "./sections/RecommendedProducts";
import RelatedArticles from "@/components/common/RelatedArticles";
import CtaBand from "@/components/common/CtaBand";
import Footer from "@/reusable_sections/Footer";
import useHashScroll from "@/hooks/useHashScroll";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const closingCtaCopy: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "Screening & Separation",
    heading: "Request a Technical Mesh & Screen Quote",
    lead: "Submit your filtration mesh specifications, custom screen dimensions, or drawing files. Our technical engineering team will review requirements and provide B2B pricing.",
    secondaryLabel: "Contact Our Team",
    note: "Manufactured with reference to ISO 9044 and ASTM E2016 standards."
  },
  zh: {
    eyebrow: "筛分与分离",
    heading: "索取工业筛网与分离介质技术报价",
    lead: "提供您的过滤筛网规格、定制尺寸或图纸文件，我们的技术工程团队将审核工况要求并提供专业的 B2B 定制报价。",
    secondaryLabel: "联系工程团队",
    note: "产品参照 ISO 9044 与 ASTM E2016 规范标准制造检验。"
  },
  es: {
    eyebrow: "Tamizado y separación",
    heading: "Solicite presupuesto técnico de mallas y cribas",
    lead: "Envíe las especificaciones de malla, dimensiones personalizadas o planos para revisión técnica y cotización B2B.",
    secondaryLabel: "Contacte con nosotros",
    note: "Fabricado con referencia a las normas ISO 9044 y ASTM E2016."
  },
  de: {
    eyebrow: "Siebung & Trennung",
    heading: "Technisches Angebot für Siebe & Trennmedien anfragen",
    lead: "Senden Sie uns Siebgewebespezifikationen, kundenspezifische Maße oder Zeichnungen zur technischen Prüfung und B2B-Kalkulation.",
    secondaryLabel: "Team kontaktieren",
    note: "Gefertigt unter Bezugnahme auf die Normen ISO 9044 und ASTM E2016."
  },
  fr: {
    eyebrow: "Criblage et séparation",
    heading: "Demandez un devis technique pour toiles et tamis",
    lead: "Transmettez vos spécifications de toile, dimensions sur mesure ou plans pour examen technique et chiffrage B2B.",
    secondaryLabel: "Nous contacter",
    note: "Fabrication selon les normes de référence ISO 9044 et ASTM E2016."
  },
  pt: {
    eyebrow: "Peneiramento e separação",
    heading: "Solicite um orçamento técnico para telas e peneiras",
    lead: "Envie as especificações de malha, dimensões sob medida ou desenhos para análise técnica e cotação B2B.",
    secondaryLabel: "Fale com a equipe",
    note: "Fabricado com referência às normas ISO 9044 e ASTM E2016."
  }
};
export default function ScreeningAndSeparationHubPage() {
  useHashScroll();
  const {
    lang
  } = useLanguage();
  const cta = pick(lang, closingCtaCopy);
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />
      <PageBreadcrumb page="ScreeningAndSeparationHub" />
      <main className="flex-1">
        <ScreeningHero />
        <ScreeningOverview />
        <PowderScreeningPanel />
        <MiningPanel />
        <SolidLiquidPanel />
        <Articles />
        <RecommendedProducts />
        <RelatedArticles topic="screening" />
        <CtaBand id="screening-closing-cta" eyebrow={cta.eyebrow} heading={cta.heading} lead={cta.lead} primary={{
        label: pick(lang, COMMON.requestQuote),
        to: "/RequestAQuotePage"
      }} secondary={{
        label: cta.secondaryLabel,
        to: "/ContactPage"
      }} note={cta.note} />
      </main>
      <Footer />
    </div>;
}